// @ts-strict-ignore
import ProvidersLogoModules from '../../../providers-logo-modules'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from '@t/fs-core'
import { getComponentById } from '@r/component/component-selectors'
import { brand } from '@r/app-selectors'
import Button from '../../../../atoms/button'
import TrustpilotAtom, { TrustpilotData } from '../../../../atoms/trustpilot'

interface CardFinderLowProminenceProps {
  jsonBody: any
  name: string
  variant: string
  rawName: string
  brand: 'money' | 'uswitch'
  sys: {
    id: string
  }
  dataset: any
  trustpilotData: TrustpilotData | undefined
}

const CardFinderLowProminence: React.FC<CardFinderLowProminenceProps> = ({
  trustpilotData,
  jsonBody,
  name,
  variant,
  rawName,
  brand,
  sys,
  dataset,
}) => {
  const eligibilityCheckUrl = '/credit-cards/eligibility-checker'
  const {
    title,
    subtitle,
    buttonText = 'Get Started',
    ctaIcon = false,
    url = eligibilityCheckUrl,
    subCategory,
    showTrustPilot,
    logosOverrideOrder,
  } = jsonBody
  const ecUrl =
    url === eligibilityCheckUrl && subCategory ? `${url}?productType=${subCategory}` : url

  try {
    return (
      <div className='CardFinderLowProm' id={name}>
        <h2 className={'CardFinderLowProm__title'}>{title}</h2>
        <div className='CardFinderLowProm__subtitle'>{subtitle}</div>
        {dataset && (
          <div className='CardFinderLowProm__providers'>
            <ProvidersLogoModules
              dataset={dataset}
              orderOverride={logosOverrideOrder || []}
              variant={'cardFinderProviders'}
              name={'CardFinderLowProminence Providers'}
              clickable={false}
              heading={''}
            />
          </div>
        )}
        {showTrustPilot && trustpilotData && (
          <TrustpilotAtom trustpilotData={trustpilotData} brand={brand}></TrustpilotAtom>
        )}
        <a
          className='CardFinderLowProm__anchor'
          href={ecUrl}
          /* eslint-disable camelcase */
          data-click-tracking={JSON.stringify({
            component_category: 'platinum-component',
            component_id: sys?.id,
            component_name: 'cardFinderLowProm',
            contentful_name: rawName,
            contentful_variant: variant,
            additionalProps: { text: buttonText },
          })}
        >
          <Button variant='primary' size='lg' withIcon={ctaIcon}>
            {buttonText}
          </Button>
        </a>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state: FsCore.State, props: any) => {
  const { sys } = props
  return {
    brand: brand(state),
    trustpilotData: getComponentById(state, sys.id)?.trustpilotData,
    ...props,
  }
})(CardFinderLowProminence)
